(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('ASTBMsoDeleteController',MsoDeleteController);

    MsoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Mso'];

    function MsoDeleteController($uibModalInstance, entity, Mso) {
        var vm = this;

        vm.mso = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id, msoName) {
            Mso.delete({id: id, msoName: msoName},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
